/*eslint-disable */

import allCountries from '@/services/phoneCodeList.json';
import appFooter from '@/components/public/common/footer/';
import axios from 'axios';
import {
  bus
} from '@/main';
import countries from '@/services/country.json';
import domains from '@/services/domain-list.json';
import {
  mapGetters
} from 'vuex';
import root from '@/_helpers/roots';
import toast from '@/services/toast';
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';
import welcome from '@/components/welcome-popup/index';

var $ = window.jQuery = require('jquery');
// Multi Color Bg Img Of Section
export default {
  name: 'register',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      domainLists: [],
      disablebtn: true,
      fname: '',
      lname: '',
      birthdate: '',
      birthMonth: '',
      birthYear: '',
      email: '',
      confirm_email: '',
      country: '',
      username: '',
      password: '',
      submitted: false,
      errorMessage: '',
      preloader: true,
      emailInvalidField:false,
      RegisterForm: true,
      signUpFormVerifyPopup:false,
      RegisterFirstStep: true,
      mobile: '',
      countryList: [],
      allCountriesList:[],
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      price: 0,
      imageIndex:'',
      confirm_password:'',
      has_number:false,
      has_lowercase:false,
      has_uppercase:false,
      has_special:false,
      phoneNumberBlurState:false
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
  },
  mounted() {
    this.domainLists = domains;
    // this.getSubscriptionPlan();
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key],
        value: key
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    // Hide Header Buttons
    bus.$emit('hideHeaderbtn', false);
    bus.$emit('showLoginbtn', true);
    bus.$emit('showRegisterbtn', false);

    this.randomImgLoaded();
    if (this.$store.getters.isAuthenticated) {
      this.$router.push('/profile/')
    }
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
  },
  methods: {
    phoneNumberFocusMethod(){
      this.phoneNumberBlurState = true
    },
    phoneNumberBlurMethod(){
      this.phoneNumberBlurState = false
    },
    passwordValidatorMethod(){
        this.has_number = /\d/.test(this.password);
        this.has_lowercase = /[a-z]/.test(this.password);
        this.has_uppercase = /[A-Z]/.test(this.password);
        this.has_special = /[#?!@$%^&*-]/.test(this.password);
        this.password = this.password.replace(/\s/g,'')
    },
    checkValidDomain() {
      if(this.email != "") {
        let result = false;
        let email = this.email;
        let address = email.split('@').pop();
        address = address.split('.').pop();
        let domain = this.domainLists.filter(item => item === address);
        if(domain && domain.length == 0) {
          result = true;
        }
        return result;
      }
    },
    getSubscriptionPlan() {
      $('.routeloader').css({
        'display': 'flex'
      });
      let mediaListUrlLink = root.signupPlan.link;
      axios.get(mediaListUrlLink).then(response => {
        if (response.status === 200) {
          let plans = response.data.data;
          this.price = plans.filter(plan => plan.validity == 365)[0].price;
          $('.routeloader').hide();
        }
      }).catch(err => {
        console.error(err);
        $('.routeloader').hide();
      })
    },
    onSpace() {},
    countryChange(selectedCountry) {
      this.phone.country = "+" + selectedCountry.dialCode + " ";
    },
    inputFocusOut() {
      if ($('.email_change').val() != "") {
        $('.email_change').attr('type', 'password')
      }
    },
    inputFocus() {
      $('.email_change').attr('type', 'text')
    },
    randomImgLoaded() {
      $('.app-loader').show()
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x
      var element = document.getElementsByClassName('random_bgimg');
      if (x < images.length) {
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        element[0].style["background-image"] = "url(" + variation_images[x] + ")"
        this.getUserCountry();
        setTimeout(() => {
          this.preloader = false;
          $('.app-loader').hide()
        }, 1500);
      }
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    emailFieldKeyup(){
      this.emailInvalidField = false
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result && !this.checkValidDomain()) {
          this.submitted = true;
          let selectedCountry = this.countryList.filter(item => item.value == this.phone.countryCode);
          if (selectedCountry && selectedCountry.length > 0) {
            selectedCountry = selectedCountry[0].value;
          }
          let phoneNumber = this.phone.number;
          phoneNumber = phoneNumber.replace(/\s+/, "_");
          phoneNumber = phoneNumber.replace(/\s/g, "");
          phoneNumber = phoneNumber.replace("_", " ");

          phoneNumber = this.phone.countryCode + phoneNumber;
          let data = {
            first_name: this.fname,
            last_name: this.lname,
            email: this.email,
            password: this.password,
            profile: {
              auto_country: selectedCountry,
              mobile: phoneNumber
            }
          }
          this.$store.dispatch('register', data).then((res) => {
            this.RegisterForm = false;
            this.signUpFormVerifyPopup = true;
            //  this.$router.push('/login/');
             this.preloader = true;
            })
            .catch((err) => {
              if(err.data.data.email){
                this.emailInvalidField = true
              }
            })
          return
        }
      });
    },
  },
  beforeCreate: function() {
    $('body').addClass('signup public-routes');
    document.title = ' Oddvega - Signup '
  },
  beforeRouteLeave: function(to, from, next) {
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
    $('body').removeClass('signup public-routes');
    next();
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
  }
}